export default function TestimonialSection() {
  return (
    <section className="relative py-16 md:py-24 bg-background-50">
      <div className="px-6 md:px-10">
        <div className="relative max-w-5xl mx-auto">
          <svg
            className="absolute -top-8 left-0 w-32 h-16 text-accent-300/50"
            viewBox="0 0 120 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 35 Q 30 5, 60 20 T 115 10"
              stroke="currentColor"
              strokeWidth="1.5"
              fill="none"
              strokeLinecap="round"
            />
          </svg>

          <div className="flex flex-col md:flex-row rounded-2xl overflow-hidden bg-foreground-950">
            <div className="md:w-2/5 relative -mb-8 md:-mb-0 md:-ml-8 z-10">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20young%20professional%20woman%20in%20stylish%20cream%20blazer%20against%20warm%20terracotta%20studio%20backdrop%2C%20soft%20golden%20hour%20lighting%2C%20editorial%20fashion%20photography%20with%20natural%20confident%20expression%2C%20clean%20composition%20with%20subtle%20shadows%20and%20professional%20polish&width=600&height=800&seq=testimonial-portrait-v2&orientation=portrait"
                alt="Community testimonial"
                className="w-full h-full object-cover object-top rounded-2xl md:rounded-none"
                loading="lazy"
              />
            </div>

            <div className="md:w-3/5 p-8 md:p-12 flex flex-col justify-center">
              <span className="font-display text-6xl md:text-8xl text-accent-300/30 leading-none select-none">&ldquo;</span>
              <p className="text-white/80 text-base md:text-lg leading-relaxed -mt-4">
                Finding quality items used to take me hours of scrolling through random threads. The PandabuySpreadsheet directory changed everything — now I can browse 14 organized categories and find exactly what I need in minutes. The daily updates keep everything fresh.
              </p>
              <div className="mt-6">
                <p className="text-white text-sm font-semibold">Marcus Rivera</p>
                <p className="text-white/50 text-xs mt-0.5">Fashion Enthusiast &amp; Community Reviewer</p>
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-6 py-2.5 mt-6 text-sm font-semibold rounded-full bg-accent-400 text-foreground-900 whitespace-nowrap hover:bg-accent-300 transition-colors w-fit"
              >
                Explore Spreadsheet
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}